// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "gateway_headerArrow-3k7kc";
var _4 = "iframe-3016Q";
export { _1 as "__esModule", _2 as "mobile", _3 as "gateway_headerArrow", _4 as "iframe" }
export default { "__esModule": _1, "mobile": _2, "gateway_headerArrow": _3, "iframe": _4 }
